import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
const ZohoFormIframe = () => {
  const [formUrl, setFormUrl] = useState("");
  const userInfo = useSelector((state) => state.user);
  const location = useLocation();
  console.log(userInfo?.data);
  useEffect(() => {
    const buildZohoFormUrl = () => {
      const searchParams = new URLSearchParams(location.search);
      const application = searchParams.get("application") || "TraineryLearn";
      const base =
        "https://forms.zohopublic.com/traineryone/form/SupportTicket/formperma/TEKiY5dgNN-q5Yl1n_6lb1b5DOLt_mIYDuLlWyymu08";

      const params = new URLSearchParams({
        zf_enablecamera: "true",
        Name_First: userInfo?.data?.first_name || "",
        Name_Last: userInfo?.data?.last_name || "",
        Email: userInfo?.data?.email || "",
        PhoneNumber: userInfo?.data?.phone_number || "",
        Dropdown: application,
        MultiLine: "Enter Your Description Here",
        SingleLine1: "Subject here",
        Name1_First: userInfo?.data?.organization?.client_id || "",
        Name1_Last: userInfo?.data?.organization?.name || "",
        SingleLine: application,
      });

      return `${base}?${params.toString()}`;
    };

    const rawUrl = buildZohoFormUrl();
    setFormUrl(rawUrl);
  }, [location.search, userInfo]);

  return (
    <div style={{ height: "100vh", width: "100%", overflow: "hidden" }}>
      <iframe
        src={formUrl}
        style={{ height: "100%", width: "100%", border: "none" }}
        frameBorder="0"
        allow="camera"
        title="Zoho Form"
      />
    </div>
  );
};

export default ZohoFormIframe;
